import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import useNavAction from 'hooks/actions/useNavAction';
import FocusableButton from 'components/common/FocusableButton';
import HBox from 'components/common/HBox';



const category = 'Exercise';
export default function ExerciseTabs(props) {
  const {
    triggered: triggeredReportExerciseSteps,
    onTrigger: onTriggerReportExerciseSteps,
  } = useNavAction('ReportExerciseSteps', { category });

  const {
    triggered: triggeredReportExerciseCalories,
    onTrigger: onTriggerReportExerciseCalories,
  } = useNavAction('ReportExerciseCalories', { category });

  return (
    <HBox {...ex('ExerciseTabs', props)}>
      <FocusableButton {...ex(['ViewModeButton', { triggered: triggeredReportExerciseSteps }], { onClick: onTriggerReportExerciseSteps() })}>
        {T('걸음수')}
      </FocusableButton>
      <FocusableButton {...ex(['ViewModeButton', { triggered: triggeredReportExerciseCalories }], { onClick: onTriggerReportExerciseCalories() })}>
        {T('소모칼로리')}
      </FocusableButton>
    </HBox>
  );
}
